module.exports = __webpack_public_path__ + "media/src/assets/images/lps-buy_investment-5ee3131ea9c268e737af246caea5c7f6.png";